import { Link } from "react-router-dom";
import { DagazMark } from "@/components/Logo";
import { SERVICES, SITE } from "@/data/content";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-graphite bg-noise text-chalk">
            <div className="px-6 md:px-12 lg:px-16 pt-24 pb-16 border-b border-chalk/10">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
                    <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight">
                        Build what<br /><span className="italic text-gold">endures.</span>
                    </h2>
                    <Link
                        to="/start-a-project"
                        data-testid="footer-cta-start-project"
                        className="group inline-flex items-center gap-3 self-start lg:self-auto px-8 py-4 border border-chalk/30 font-sans text-xs font-semibold tracking-[0.22em] uppercase transition-colors duration-500 hover:border-gold hover:text-gold"
                    >
                        Start a Project
                        <span className="inline-block transition-transform duration-500 group-hover:translate-x-1.5" aria-hidden="true">→</span>
                    </Link>
                </div>
            </div>

            <div className="px-6 md:px-12 lg:px-16 py-16 grid grid-cols-2 md:grid-cols-12 gap-10">
                <div className="col-span-2 md:col-span-4">
                    <DagazMark className="w-8 h-8 text-chalk mb-6" />
                    <p className="font-sans text-sm text-fog leading-relaxed max-w-xs">
                        European design, built by licensed local partners. From our Oregon office across the United States and Canada.
                    </p>
                </div>
                <div className="md:col-span-3">
                    <p className="font-sans text-[10px] font-medium tracking-[0.28em] uppercase text-slate mb-6">Services</p>
                    <ul className="space-y-3">
                        {SERVICES.map((s) => (
                            <li key={s.slug}>
                                <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="font-sans text-sm text-fog hover:text-gold transition-colors duration-300">
                                    {s.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:col-span-2">
                    <p className="font-sans text-[10px] font-medium tracking-[0.28em] uppercase text-slate mb-6">Company</p>
                    <ul className="space-y-3">
                        {[["Projects", "/projects"], ["Process", "/how-it-works"], ["Financing", "/financing"], ["Partners", "/partners"], ["About", "/about"], ["FAQ", "/faq"], ["Contact", "/contact"], ["Privacy", "/privacy"]].map(([label, to]) => (
                            <li key={to}>
                                <Link to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="font-sans text-sm text-fog hover:text-gold transition-colors duration-300">
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:col-span-3">
                    <p className="font-sans text-[10px] font-medium tracking-[0.28em] uppercase text-slate mb-6">Contact</p>
                    <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="font-serif text-xl text-chalk hover:text-gold transition-colors duration-300 link-rule">
                        {SITE.email}
                    </a>
                    <p className="font-sans text-sm text-fog mt-6 leading-relaxed">
                        Oregon, Pacific Northwest<br />
                        Serving all US states &<br />Canadian provinces
                    </p>
                </div>
            </div>

            <div className="px-6 md:px-12 lg:px-16 py-6 border-t border-chalk/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                <p className="font-sans text-[11px] tracking-[0.18em] text-slate uppercase">© 2026 Dagaz Development</p>
                <p className="font-sans text-[11px] tracking-[0.18em] text-slate uppercase">Build / Renovate / Craft</p>
            </div>
        </footer>
    );
}
